// This file is generated by a script and should not be modified directly.
const markdown: string =
  "List of companies that have not posted a job offer but are likely to hire apprentices in the desired field.\n\nThe results are limited to 150, and currently, it is not possible to retrieve all recruiters matching the search criteria.\n"
export default markdown
